module.exports = __webpack_public_path__ + "media/images/bnr-language-7254dd07702d236536419e960017082e.png";